module.exports = __webpack_public_path__ + "img/logo.6c63d77a.png";